import React from 'react';

const ViewDetails = ({ props: { ViewHtmlDetails, setViewHtmlDetails } }) => {

    const { name, img, technology, link, html, new: newP } = ViewHtmlDetails;
    const badge = [' badge-primary', 'badge-secondary', 'badge-accent']

    return (
        <div>
            <input type="checkbox" id="veiwDetails" class="modal-toggle" />

            <label for="veiwDetails" class="modal cursor-pointer">
                <label class="modal-box relative" for="">
                    <div className="card w-full  sm:w-96 bg-base-100 shadow-xl">
                        <figure><img src={img} alt="Shoes" className='w-full sm:w-[400px] h-[250px]' /></figure>
                        <div className="card-body">
                            <h2 className="card-title">
                                {name}
                                {
                                    newP && <div className="badge badge-secondary">new</div>
                                }
                            </h2>
                            <div className="card-actions justify-end">
                                {
                                    technology?.map((tec, i) => <div key={i} class={"badge " + badge[Math.floor(Math.random() * badge.length)]}>{tec}</div>)
                                }
                            </div>
                            <div className="flex justify-between items-center mt-1">

                                {
                                    link?.live && <a href={link?.live} className="btn btn-outline btn-sm" target='_blank' rel="noreferrer">Live</a>
                                }
                                {
                                    link?.github && <a href={link?.github} className="btn btn-outline btn-sm" target='_blank' rel="noreferrer">GitHub</a>
                                }
                                {
                                    link?.githubServer && <a href={link?.githubServer} className="btn  btn-outline btn-sm" target='_blank' rel="noreferrer">Server</a>
                                }

                            </div>
                            <div dangerouslySetInnerHTML={{ __html: html }}></div>

                        </div>
                    </div>
                </label>
            </label>
        </div>
    );
};

export default ViewDetails;